<template>
  <div class="blog-card">
    <el-row
      class="blog-card__body"
      :class="{
        'blog-card__body--odd': index % 2 === 1,
        'blog-card__body--even': index % 2 === 0,
      }"
      :gutter="100"
      type="flex"
      align="middle"
    >
      <el-col :xs="24" :md="12">
        <div class="blog-card__img-wrapper">
          <a :href="`/blogs/${data.seo_slug}`">
            <div class="img-content">
              <v-lazy-img
                :src="data.cover && data.cover.thumbnail"
                :data-url="data.cover && data.cover.url"
                class="img-content__img"
              />
            </div>
          </a>
        </div>
      </el-col>

      <el-col :xs="24" :md="12">
        <div class="blog-card__content">
          <p class="blog-card__title">
            <a :href="`/blogs/${data.seo_slug}`">
              {{ data.title }}
            </a>
          </p>
          <p class="blog-card__collection-title">
            <template v-for="(collection, index) in data.collections">
              <span :key="collection.id">
                <span>{{ collection.title }}</span>
                <span v-if="index < data.collections.length - 1">, </span>
              </span>
            </template>
          </p>

          <p class="blog-card__desc">
            {{ data.summary }}
          </p>
        </div>
        <div class="blog-card__footer">
          <a :href="`/blogs/${data.seo_slug}`">{{ $t("read_more") }}</a>
          <span class="card-footer__info">
            <span>{{ new Date(data.visible_at).format("dd.MM.yyyy") }}</span>
            <span class="blog-line">&#124;</span>
            <span>{{ data.author }}</span>
          </span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
//import LazyImg from "@/js/components/LazyImg.vue";

export default {
  // components: {
  //   [LazyImg.name]: LazyImg,
  // },
  name: "VBlogCard",
  props: {
    data: {
      type: Object,
      require: true,
    },
    index: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/mobile.scss";

p {
  margin: 0;
}
.blog-line {
  display: inline-block;
  border: none;
  margin: 0 8px;
}
.blog-card {
  // background: #ffffff;
  padding: 40px 0;
  border-bottom: 1px solid #eaeaea;
  color: #222a40;
  &__body {
    &--odd {
      flex-direction: row-reverse;
    }
  }
  &__img-wrapper {
    width: 100%;
    position: relative;
    .img-content {
      height: 100%;
      width: 100%;
      position: absolute;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      &__img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &::after {
      content: "";
      display: block;
      padding-top: 100%;
    }
  }
  &__footer {
    margin-top: 60px;
    color: #888;
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1;
    font-size: 16px;
    a {
      text-transform: capitalize;
      font-weight: 500;
      color: #222a40;
      text-decoration: underline;
    }
  }
  .card-footer {
    &__info {
      display: flex;
      align-items: center;
    }
  }
  &__title {
    font-size: 24px;
    color: #222a40;
    line-height: 34px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    a {
      color: inherit;
    }
  }
  &__collection-title {
    margin-top: 14px;
    color: #888;
  }
  &__desc {
    margin-top: 25px;
    font-size: 16px;
    line-height: 26px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  /* 移动端适配 */
  @media only screen and (max-width: 767px) {
    padding: px(20) 0;
    &__body {
      display: block;
      overflow: hidden;
    }
    &__title {
      font-size: px(14);
      margin-top: px(15);
      line-height: px(24);
    }
    &__collection-title {
      font-size: px(12);
      margin-top: px(15);
    }
    &__desc {
      font-size: px(14);
      margin-top: px(15);
      line-height: px(24);
    }
    &__footer {
      margin-top: px(30);
      font-size: px(14);
    }
  }
}
</style>


